import React, { useState, useEffect } from 'react';
import { db } from '../config/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import './ContentManager.css';

const ContentManager = () => {
  const [activeTab, setActiveTab] = useState('home');
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  // Home Content
  const [homeContent, setHomeContent] = useState({
    heroTexts: [
      { line1: 'KESİNTİSİZ YAYIN', line2: '4K KALİTE' },
      { line1: 'GÜÇLÜ ALTYAPI', line2: 'HIZLI ERİŞİM' },
      { line1: 'SINIRSIZ EĞLENCE', line2: 'HER CİHAZDA' }
    ],
    heroDescription: 'Binlerce içeriğe anında erişin. Türkiye\'nin en güçlü IPTV altyapısı.',
    stats: {
      channels: '45.000+',
      movies: '72.223+',
      series: '25.285+'
    },
    features: [
      { icon: '🎬', title: 'Zengin İçerik', description: 'En güncel filmler, popüler diziler ve dünya çapında binlerce canlı kanal.' },
      { icon: '⚡', title: 'Hızlı Aktivasyon', description: 'Ödemeniz onaylandığı an üyeliğiniz aktif edilir. Anında izlemeye başlayın.' },
      { icon: '🛡️', title: 'Kesintisiz Yayın', description: 'Anti-Freeze teknolojimiz ile donma ve takılma yaşamadan izleyin.' }
    ],
    featuredPackage: {
      name: '6 AY PAKET',
      price: '1.300',
      originalPrice: '2.000',
      features: ['55.000+ Kanal & İçerik', '4K Ultra HD Yayın', '7/24 Canlı Destek', 'Tüm Cihazlarla Uyumlu']
    }
  });

  // About Content
  const [aboutContent, setAboutContent] = useState({
    story: 'Elit IPTV, 2020 yılında Berlin, Almanya\'da kurulmuş, dünya genelinde hizmet veren bir IPTV sağlayıcısıdır. Misyonumuz, kullanıcılarımıza en kaliteli, kesintisiz ve uygun fiyatlı IPTV deneyimini sunmaktır.',
    story2: 'Yüksek hızlı sunucularımız, gelişmiş teknoloji altyapımız ve 7/24 müşteri desteği ile binlerce mutlu müşteriye hizmet vermekteyiz. Türkiye ve Avrupa bölgesinde özel optimizasyonlar yaparak, en iyi izleme deneyimini garanti ediyoruz.',
    story3: 'Modern teknoloji, güvenli ödeme sistemleri ve kullanıcı odaklı yaklaşımımız ile sektörde öncü bir konumdayız. Her geçen gün kendimizi geliştirerek, müşterilerimize daha iyi hizmet sunmak için çalışıyoruz.',
    values: [
      { icon: '🎯', title: 'Güvenilirlik', description: '%99.9 uptime garantisi ile kesintisiz hizmet sunuyoruz. Sunucularımız 7/24 izlenmekte ve optimize edilmektedir.' },
      { icon: '💎', title: 'Kalite', description: 'Full HD ve 4K kalitede yayınlar, yüksek hızlı sunucular ve gelişmiş teknoloji ile en iyi deneyimi sunuyoruz.' },
      { icon: '🤝', title: 'Müşteri Odaklılık', description: '7/24 WhatsApp desteği, hızlı yanıt süreleri ve kişisel yaklaşım ile müşteri memnuniyetini ön planda tutuyoruz.' },
      { icon: '🔒', title: 'Güvenlik', description: '3D Secure ödeme sistemleri, SSL şifreleme ve güvenli veri saklama ile bilgilerinizi koruyoruz.' }
    ]
  });

  // Contact Info
  const [contactInfo, setContactInfo] = useState({
    whatsapp: '+49-163-892-6744',
    email: 'elitelk2009@gmail.com',
    address: {
      street: 'Friedrichstraße 123',
      city: 'Berlin',
      postalCode: '10117',
      country: 'Almanya'
    },
    workingHours: '7/24 Açık'
  });

  // SEO Settings
  const [seoSettings, setSeoSettings] = useState({
    siteTitle: 'Elit IPTV | Premium IPTV Hizmeti',
    siteDescription: 'Elit IPTV ile 50.000+ canlı TV kanalı, 72.000+ film ve dizi arşivine erişin. 4K Ultra HD kalite, kesintisiz yayın.',
    siteKeywords: 'iptv, iptv türkiye, iptv paket, canlı tv, film izle, dizi izle, 4k iptv',
    siteUrl: 'https://elitiptv.net'
  });

  useEffect(() => {
    loadContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const loadContent = async () => {
    try {
      setLoading(true);
      const contentMap = {
        home: 'homeContent',
        about: 'aboutContent',
        contact: 'contactInfo',
        seo: 'seoSettings'
      };

      const docRef = doc(db, 'content', contentMap[activeTab]);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        if (activeTab === 'home') setHomeContent(data);
        else if (activeTab === 'about') setAboutContent(data);
        else if (activeTab === 'contact') setContactInfo(data);
        else if (activeTab === 'seo') setSeoSettings(data);
      }
    } catch (err) {
      console.error('Load content error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      setSaved(false);

      const contentMap = {
        home: { data: homeContent, doc: 'homeContent' },
        about: { data: aboutContent, doc: 'aboutContent' },
        contact: { data: contactInfo, doc: 'contactInfo' },
        seo: { data: seoSettings, doc: 'seoSettings' }
      };

      const { data, doc: docName } = contentMap[activeTab];
      await setDoc(doc(db, 'content', docName), {
        ...data,
        updatedAt: new Date().toISOString()
      });

      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
      window.dispatchEvent(new CustomEvent('showToast', { 
        detail: { message: '✅ İçerikler başarıyla kaydedildi', type: 'success' } 
      }));
    } catch (err) {
      console.error('Save error:', err);
      window.dispatchEvent(new CustomEvent('showToast', { 
        detail: { message: '❌ Kaydetme hatası: ' + err.message, type: 'error' } 
      }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-manager">
      <div className="manager-header">
        <h2>✏️ İçerik Yönetimi</h2>
        <div className="header-actions">
          <div className="content-tabs">
            <button 
              className={activeTab === 'home' ? 'active' : ''}
              onClick={() => setActiveTab('home')}
            >
              🏠 Ana Sayfa
            </button>
            <button 
              className={activeTab === 'about' ? 'active' : ''}
              onClick={() => setActiveTab('about')}
            >
              ℹ️ Hakkımızda
            </button>
            <button 
              className={activeTab === 'contact' ? 'active' : ''}
              onClick={() => setActiveTab('contact')}
            >
              📞 İletişim
            </button>
            <button 
              className={activeTab === 'seo' ? 'active' : ''}
              onClick={() => setActiveTab('seo')}
            >
              🔍 SEO
            </button>
          </div>
          <button 
            onClick={handleSave} 
            className="btn-save"
            disabled={loading}
          >
            {loading ? '⏳ Kaydediliyor...' : saved ? '✅ Kaydedildi!' : '💾 Kaydet'}
          </button>
        </div>
      </div>

      <div className="content-editor">
        {activeTab === 'home' && (
          <HomeContentEditor content={homeContent} setContent={setHomeContent} />
        )}
        {activeTab === 'about' && (
          <AboutContentEditor content={aboutContent} setContent={setAboutContent} />
        )}
        {activeTab === 'contact' && (
          <ContactInfoEditor content={contactInfo} setContent={setContactInfo} />
        )}
        {activeTab === 'seo' && (
          <SEOSettingsEditor content={seoSettings} setContent={setSeoSettings} />
        )}
      </div>
    </div>
  );
};

// Home Content Editor Component
const HomeContentEditor = ({ content, setContent }) => {
  const updateHeroText = (index, field, value) => {
    const newHeroTexts = [...content.heroTexts];
    newHeroTexts[index][field] = value;
    setContent({ ...content, heroTexts: newHeroTexts });
  };

  const updateStat = (key, value) => {
    setContent({
      ...content,
      stats: { ...content.stats, [key]: value }
    });
  };

  const updateFeature = (index, field, value) => {
    const newFeatures = [...content.features];
    newFeatures[index][field] = value;
    setContent({ ...content, features: newFeatures });
  };

  return (
    <div className="content-section">
      <h3>🏠 Ana Sayfa İçerikleri</h3>

      <div className="form-section">
        <h4>Hero Bölümü</h4>
        <div className="form-group">
          <label>Açıklama Metni</label>
          <textarea
            value={content.heroDescription}
            onChange={(e) => setContent({ ...content, heroDescription: e.target.value })}
            rows="3"
          />
        </div>

        <div className="form-group">
          <label>Hero Metinleri (3 adet)</label>
          {content.heroTexts.map((text, index) => (
            <div key={index} className="hero-text-editor">
              <input
                type="text"
                value={text.line1}
                onChange={(e) => updateHeroText(index, 'line1', e.target.value)}
                placeholder="Satır 1"
              />
              <input
                type="text"
                value={text.line2}
                onChange={(e) => updateHeroText(index, 'line2', e.target.value)}
                placeholder="Satır 2"
              />
            </div>
          ))}
        </div>
      </div>

      <div className="form-section">
        <h4>İstatistikler</h4>
        <div className="stats-editor">
          <div className="form-group">
            <label>📺 Kanal Sayısı</label>
            <input
              type="text"
              value={content.stats.channels}
              onChange={(e) => updateStat('channels', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>🎬 Film Sayısı</label>
            <input
              type="text"
              value={content.stats.movies}
              onChange={(e) => updateStat('movies', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>📱 Dizi Sayısı</label>
            <input
              type="text"
              value={content.stats.series}
              onChange={(e) => updateStat('series', e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="form-section">
        <h4>Özellikler (3 Kart)</h4>
        {content.features.map((feature, index) => (
          <div key={index} className="feature-editor">
            <div className="form-group">
              <label>İkon</label>
              <input
                type="text"
                value={feature.icon}
                onChange={(e) => updateFeature(index, 'icon', e.target.value)}
                placeholder="🎬"
              />
            </div>
            <div className="form-group">
              <label>Başlık</label>
              <input
                type="text"
                value={feature.title}
                onChange={(e) => updateFeature(index, 'title', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Açıklama</label>
              <textarea
                value={feature.description}
                onChange={(e) => updateFeature(index, 'description', e.target.value)}
                rows="2"
              />
            </div>
          </div>
        ))}
      </div>

      <div className="form-section">
        <h4>Öne Çıkan Paket</h4>
        <div className="form-group">
          <label>Paket Adı</label>
          <input
            type="text"
            value={content.featuredPackage.name}
            onChange={(e) => setContent({
              ...content,
              featuredPackage: { ...content.featuredPackage, name: e.target.value }
            })}
          />
        </div>
        <div className="form-group">
          <label>Fiyat</label>
          <input
            type="text"
            value={content.featuredPackage.price}
            onChange={(e) => setContent({
              ...content,
              featuredPackage: { ...content.featuredPackage, price: e.target.value }
            })}
          />
        </div>
        <div className="form-group">
          <label>Eski Fiyat</label>
          <input
            type="text"
            value={content.featuredPackage.originalPrice}
            onChange={(e) => setContent({
              ...content,
              featuredPackage: { ...content.featuredPackage, originalPrice: e.target.value }
            })}
          />
        </div>
      </div>
    </div>
  );
};

// About Content Editor Component
const AboutContentEditor = ({ content, setContent }) => {
  return (
    <div className="content-section">
      <h3>ℹ️ Hakkımızda Sayfası</h3>

      <div className="form-section">
        <h4>Hikaye Metinleri</h4>
        <div className="form-group">
          <label>Paragraf 1</label>
          <textarea
            value={content.story}
            onChange={(e) => setContent({ ...content, story: e.target.value })}
            rows="4"
          />
        </div>
        <div className="form-group">
          <label>Paragraf 2</label>
          <textarea
            value={content.story2}
            onChange={(e) => setContent({ ...content, story2: e.target.value })}
            rows="4"
          />
        </div>
        <div className="form-group">
          <label>Paragraf 3</label>
          <textarea
            value={content.story3}
            onChange={(e) => setContent({ ...content, story3: e.target.value })}
            rows="4"
          />
        </div>
      </div>

      <div className="form-section">
        <h4>Değerler (4 Kart)</h4>
        {content.values.map((value, index) => (
          <div key={index} className="value-editor">
            <div className="form-group">
              <label>İkon</label>
              <input
                type="text"
                value={value.icon}
                onChange={(e) => {
                  const newValues = [...content.values];
                  newValues[index].icon = e.target.value;
                  setContent({ ...content, values: newValues });
                }}
              />
            </div>
            <div className="form-group">
              <label>Başlık</label>
              <input
                type="text"
                value={value.title}
                onChange={(e) => {
                  const newValues = [...content.values];
                  newValues[index].title = e.target.value;
                  setContent({ ...content, values: newValues });
                }}
              />
            </div>
            <div className="form-group">
              <label>Açıklama</label>
              <textarea
                value={value.description}
                onChange={(e) => {
                  const newValues = [...content.values];
                  newValues[index].description = e.target.value;
                  setContent({ ...content, values: newValues });
                }}
                rows="3"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Contact Info Editor Component
const ContactInfoEditor = ({ content, setContent }) => {
  return (
    <div className="content-section">
      <h3>📞 İletişim Bilgileri</h3>

      <div className="form-section">
        <div className="form-group">
          <label>📱 WhatsApp Numarası</label>
          <input
            type="text"
            value={content.whatsapp}
            onChange={(e) => setContent({ ...content, whatsapp: e.target.value })}
            placeholder="+49-163-892-6744"
          />
        </div>

        <div className="form-group">
          <label>✉️ E-posta</label>
          <input
            type="email"
            value={content.email}
            onChange={(e) => setContent({ ...content, email: e.target.value })}
            placeholder="elitelk2009@gmail.com"
          />
        </div>

        <div className="form-group">
          <label>📍 Sokak Adresi</label>
          <input
            type="text"
            value={content.address.street}
            onChange={(e) => setContent({
              ...content,
              address: { ...content.address, street: e.target.value }
            })}
          />
        </div>

        <div className="form-group">
          <label>🏙️ Şehir</label>
          <input
            type="text"
            value={content.address.city}
            onChange={(e) => setContent({
              ...content,
              address: { ...content.address, city: e.target.value }
            })}
          />
        </div>

        <div className="form-group">
          <label>📮 Posta Kodu</label>
          <input
            type="text"
            value={content.address.postalCode}
            onChange={(e) => setContent({
              ...content,
              address: { ...content.address, postalCode: e.target.value }
            })}
          />
        </div>

        <div className="form-group">
          <label>🌍 Ülke</label>
          <input
            type="text"
            value={content.address.country}
            onChange={(e) => setContent({
              ...content,
              address: { ...content.address, country: e.target.value }
            })}
          />
        </div>

        <div className="form-group">
          <label>🕒 Çalışma Saatleri</label>
          <input
            type="text"
            value={content.workingHours}
            onChange={(e) => setContent({ ...content, workingHours: e.target.value })}
            placeholder="7/24 Açık"
          />
        </div>
      </div>
    </div>
  );
};

// SEO Settings Editor Component
const SEOSettingsEditor = ({ content, setContent }) => {
  return (
    <div className="content-section">
      <h3>🔍 SEO Ayarları</h3>

      <div className="form-section">
        <div className="form-group">
          <label>Site Başlığı</label>
          <input
            type="text"
            value={content.siteTitle}
            onChange={(e) => setContent({ ...content, siteTitle: e.target.value })}
          />
        </div>

        <div className="form-group">
          <label>Meta Açıklama</label>
          <textarea
            value={content.siteDescription}
            onChange={(e) => setContent({ ...content, siteDescription: e.target.value })}
            rows="3"
          />
        </div>

        <div className="form-group">
          <label>Anahtar Kelimeler (virgülle ayrılmış)</label>
          <input
            type="text"
            value={content.siteKeywords}
            onChange={(e) => setContent({ ...content, siteKeywords: e.target.value })}
          />
        </div>

        <div className="form-group">
          <label>Site URL</label>
          <input
            type="url"
            value={content.siteUrl}
            onChange={(e) => setContent({ ...content, siteUrl: e.target.value })}
          />
        </div>
      </div>
    </div>
  );
};

export default ContentManager;
